<template>
  <div>
    <form @submit.prevent="submit">
      <b-row>
        <b-col cols="12" md="6">
          <b-form-group label="Contraseña">
            <b-form-input
               id="password"
                 ref="password"
              type="password"
              v-model="password"
              data-vv-validate-on="blur|input"
              data-vv-name="password"
              v-validate.initial="'required|min:6'"
              :state="!errors.has('password')"
            />
          <span class="text-danger fs-6" v-show="errors.has('password')">{{
              errors.first("password")
            }}</span>
          </b-form-group>
        </b-col>
        <b-col cols="12" md="6">
          <b-form-group label="Confirmar Contraseña">
            <b-form-input
      
              id="confirmar"
              v-validate.initial="'required|confirmed:password'"
              type="password"
              data-vv-validate-on="blur|input"
              data-vv-name="confirmar"
              v-model="confirmPassword"
              :state="!errors.has('confirmar')"
            />
            <span class="text-danger fs-6" v-show="errors.has('confirmar')">{{
              errors.first("confirmar")
            }}</span>
          </b-form-group>
        </b-col>
      </b-row>
       <div class="text-right">
        <b-button type="submit" variant="success">Cambiar contraseña</b-button>
      </div>
    </form>
  </div>
</template>
<script>
export default {
    props:{
        cleanForm:{
            type:Date,
        }
    },
  data() {
    return {
      password: "",
      confirmPassword: "",
    };
  },
  methods: {
    submit() {
      this.$validator.validate().then((valid) => {
        if (valid) {
          this.$emit("handleChangePassword", this.password);
          
        }
      });
    },
  },
  watch:{
      cleanForm(){
          this.password = "";
          this.confirmPassword = ""
      }
  }
};
</script>
<style scoped></style>
